import { certificatesAtom, themeAtom } from "../../shared/atoms";
import { useAtom, useAtomValue } from "jotai";
import { useRef, useEffect } from "react";
import { twMerge } from "tailwind-merge";

export function CertificatesTableHeader() {
  const theme = useAtomValue(themeAtom);

  const [certificates, setCertificates] = useAtom(certificatesAtom);
  const checked = certificates.every((certificateAtom) => certificateAtom.isChecked);
  const indeterminate = certificates.some((certificateAtom) => certificateAtom.isChecked) && !checked;

  const checkboxRef = useRef<HTMLInputElement>(null);

  const handleCheckAll: React.MouseEventHandler<HTMLInputElement> = (event) => {
    const isChecked = event.currentTarget.checked;
    setCertificates((certificates) =>
      certificates.map((cert) => ({
        ...cert,
        isChecked,
      })),
    );
  };

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <thead
      className={twMerge(
        "sticky top-0 z-10 border-b-[1px] uppercase",
        theme.headerComponent.notifications.drawerBackground,
        theme.headerComponent.notifications.headerText,
        theme.headerComponent.notifications.headerBorder,
      )}
    >
      <tr className="text-left">
        <th className="h-14 px-4 text-[13px] font-semibold">
          <div className="flex items-center gap-2">
            <input type="checkbox" checked={checked} onClick={handleCheckAll} ref={checkboxRef} />
            Document
          </div>
        </th>
        <th className="h-14 px-4 text-[13px] font-semibold">Document Type</th>
        <th className="h-14 px-4 text-[13px] font-semibold">Source</th>
        <th className="h-14 px-4 text-[13px] font-semibold">Appendix</th>
        <th className="h-14 px-4 text-[13px] font-semibold">Expires</th>
        <th className="h-14 px-4 text-[13px] font-semibold">Next Survey</th>
        <th className="h-14 px-4 text-[13px] font-semibold">Alerts</th>
        <th />
      </tr>
    </thead>
  );
}
